var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('terms-list-link',{attrs:{"listLayout":_vm.listLayout,"termsData":_vm.List,"paginationData":_vm.filterSet.page,"termsType":_vm.termsType}}),_c('pagination-link',{attrs:{"paginationLayout":_vm.paginationLayout,"paginationData":_vm.filterSet.page,"listLength":_vm.List.length}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }